import { useWindowWidth } from "@react-hook/window-size";
import React from "react";
import Inlinenavbar from "../../Inlinenavbar";
import AntDrawer from "../AntDrawer";

const Sidebar = ({ visible, setVisible, items }) => {
  const isMobile = useWindowWidth() > 768;
  const onClose = () => {
    setVisible(false);
  };
  return (
    <div>
      <AntDrawer
        visible={visible}
        size={isMobile ? "large" : "small"}
        onClose={onClose}
        children={<Inlinenavbar items={items} setVisible={setVisible} />}
      />
    </div>
  );
};

export default Sidebar;
